<template>
  <div class="inputPanel inputPanel__error errorBox_common" v-if="invalid_fields">
    <div class="inputPanel__errorMsg errorMsg" style="margin-bottom:20px">
      <div v-if="invalidFields.email || invalidFields.contact_phone || invalidFields.company_name || invalidFields.name">
        <h3 v-if="invalidFields.email" style="margin:0">Please enter a valid business email address</h3>
        <h3 v-if="invalidFields.contact_phone">Please enter a valid phone number</h3>
        <h3 v-if="invalidFields.company_name || invalidFields.name">Please enter your details above and click Save & Continue</h3>
      </div>
      <h3 v-else>Please answer all questions above before progressing</h3>
    </div>
  </div>
</template>
<script>
  import {mapState} from 'vuex'

  export default {
    created() {
//      this.$root.$on('update-global-error-stupid-thing', (invalidFields) => {
//        console.log('test')
//        this.invalid_fields = invalidFields && Object.keys(invalidFields).length > 0
//      })

    },
    computed: {
      ...mapState('QuoteForm', ['invalidFields']),
      invalid_fields: {
        get() {
          return this.invalidFields && Object.keys(this.invalidFields).length > 0
        }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/views/Quotes/Form/InvalidFieldsModal.vue